import {KeyBindController, ShortcutLocation} from '../KeyBindController.ts'
import {createDivIn, setElementOnClick} from '../ui_utils/DomUtils.ts'

export abstract class UIPopup {
    protected container: HTMLDivElement

    constructor() {
        this.container = createDivIn(document.body, 'popup')
        setElementOnClick(this.container, (event: MouseEvent) => this.containerClicked(event))
    }

    private containerClicked(event: MouseEvent) {
        if(event.target !== this.container) return
        this.hide()
    }

    show() {
        this.container.style.display = 'block'
    }

    hide() {
        this.container.style.display = 'none'
    }

    isHidden(): boolean {
        return this.container.style.display == 'none'
    }

    setEscapeKeyBind() {
        KeyBindController.bindKey('Escape', () => this.hide(), () => !this.isHidden(), ShortcutLocation.General)
    }

    removePopup() {
        this.container.style.display = 'none'
        if(this.container.parentElement != undefined) this.container.parentElement.removeChild(this.container)
    }
}
